module.exports = __webpack_public_path__ + "img/veranoReCreativo_color-19.0b034b92.png";